
import React from "react";
import { motion } from "framer-motion";

export function PulsatingLink({ onClick }) {
  return (
    <div className="text-center mt-32 mb-8">
      <button
        onClick={onClick}
        className="text-[#ff3366] text-lg font-semibold hover:text-[#ff3366]/80 glow"
      >
        Baixe a Lista de Exames Necessários
      </button>
    </div>
  );
}
